import React from "react";
import { FaBookOpen, FaCalculator, FaLeaf, FaGlobe, FaDesktop, FaLanguage } from "react-icons/fa";

export default function Primary() {
  const subjects = [
    {
      name: "English",
      icon: <FaBookOpen className="text-green-900 text-3xl mb-3" />,
      description:
        "Focuses on reading, writing, grammar, and spoken English through stories and activities.",
    },
    {
      name: "Mathematics",
      icon: <FaCalculator className="text-green-900 text-3xl mb-3" />,
      description:
        "Covers numbers, operations, patterns, measurements, and problem-solving skills.",
    },
    {
      name: "Environmental Studies",
      icon: <FaLeaf className="text-green-900 text-3xl mb-3" />,
      description:
        "Teaches children about nature, surroundings, science, and good habits.",
    },
    {
      name: "General Knowledge",
      icon: <FaGlobe className="text-green-900 text-3xl mb-3" />,
      description:
        "Enhances curiosity through fun facts, puzzles, and world awareness.",
    },
    {
      name: "Computer Basics",
      icon: <FaDesktop className="text-green-900 text-3xl mb-3" />,
      description:
        "Introduction to computers, typing, and learning through digital tools.",
    },
    {
      name: "Second Language",
      icon: <FaLanguage className="text-green-900 text-3xl mb-3" />,
      description:
        "Optional language classes like Telugu or Hindi based on regional preference.",
    },
  ];

  return (
    <section className="w-full px-4 py-10 md:px-16 lg:px-24 bg-green-900 text-white min-h-screen">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold mb-2">Primary Curriculum</h2>
        <p className="text-lg text-gray-200 max-w-2xl mx-auto">
          Our curriculum is designed to foster creativity, encourage curiosity, and develop essential academic and life skills.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {subjects.map((subject, idx) => (
          <div
            key={idx}
            className="bg-white text-green-900 p-6 rounded-xl shadow hover:shadow-lg transition-all"
          >
            <div className="flex flex-col items-center text-center">
              {subject.icon}
              <h4 className="text-xl font-semibold mb-2">{subject.name}</h4>
              <p className="text-sm text-gray-700">{subject.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
